














































































































































import { Mixins, Component, Prop } from 'vue-property-decorator'
import intToBase64 from 'src/assets/intToBase64'
import confirm from 'components/modals/Confirm'
import MixinForm from 'components/presenter/item/topic/editor/MixinForm'

@Component
export default class ItemTopicSlidesEditorFormParams extends Mixins(MixinForm) {

  @Prop()
  readonly correct!: string[]

  get name () {
    const name = intToBase64(this.slide.id).replace(/[\+\/]/, '&').substr(0, 6).toUpperCase()
    return name.substr(0, 3) + '-' + name.substr(3, 3)
  }

  get xvars () {
    return this.slide.x || []
  }

  get xrand () {
    return this.slide.rand || {}
  }

  get yvars () {
    return this.slide.y || []
  }

  get yrand () {
    return this.correct || {}
  }

  get sets () {
    return Object.keys(this.xrand)
  }

  async del () {
    await confirm({
      title: this.$t('label.deleteConfirm').toString(),
      message: this.$t('slides.edit.params.delete.all').toString()
    })
    this.setOption('deleted', new Date().getTime())
  }

  xadd () {
    this.setOption('x', [...this.xvars, ''])
  }

  yadd () {
    this.setOption('y', [...this.yvars, ''])
  }

  xsave (index: number, name: string) {
    const x = [...this.xvars]
    x.splice(index, 1, name)
    this.setOption('x', x)
  }

  ysave (index: number, name: string) {
    const y = [...this.yvars]
    y.splice(index, 1, name)
    this.setOption('y', y)
  }

  xdel () {
    const x = [...this.xvars]
    x.pop()
    this.setOption('x', x)
  }

  ydel () {
    const y = [...this.yvars]
    y.pop()
    this.setOption('y', y)
  }

  rowadd () {
    const id = new Date().getTime()
    const slidesSettings: Json = {}
    const slidesCorrects: Json = {}
    slidesSettings[`${this.slide.id}:rand:${id}`] = []
    slidesCorrects[`${this.slide.id}:${id}`] = []
    this.item.data?.save({ slidesSettings, slidesCorrects })
  }

  rowsavex (id: number, index: number, value: string) {
    const rand = [...this.xrand[id]]
    while (rand.length < index) { rand.push(null) }
    rand.splice(index, 1, value || null)
    const slidesSettings: Json = {}
    slidesSettings[`${this.slide.id}:rand:${id}`] = rand
    this.item.data?.save({ slidesSettings })
  }

  rowsavey (id: number, index: number, value: number) {
    const rand: Array<string | number | null> = [...this.yrand[id]]
    while (rand.length < index) { rand.push(null) }
    rand.splice(index, 1, value ? +value : null)
    const slidesCorrects: Json = {}
    slidesCorrects[`${this.slide.id}:${id}`] = rand
    this.item.data?.save({ slidesCorrects })
  }

  async rowdel (id: number) {
    await confirm({
      title: this.$t('label.deleteConfirm').toString(),
      message: this.$t('slides.edit.params.delete.row').toString()
    })
    const slidesSettings: Json = {}
    const slidesCorrects: Json = {}
    slidesSettings[`${this.slide.id}:rand:${id}`] = null
    slidesCorrects[`${this.slide.id}:${id}`] = null
    this.item.data?.save({ slidesSettings, slidesCorrects })
  }
}
